import _ from "lodash";
import {
  FETCH_LINK_RESOURCE,
  FETCH_INTERACTIVE_MAPS,
  SHOW_ADD_BOOTH_INFO,
  SHOW_BOOTH_EDITOR,
  ADD_BOOTH_LINK,
  UPDATE_BOOTH_COLOR,
  DELETE_BOOTH_LINK,
  OPEN_IMAP,
  ADD_BOOTH,
  EDIT_BOOTH,
  CLOSE_BOOTH,
  ADD_IMAP_NAME,
  OPEN_IMAP_MODAL,
  CHANGE_MAP_IMAGE,
  MAP_IMAGE_CHANGED,
  DEFAULT_IMAP_VALUE,
  UPDATE_IMAP_UPLOAD_PROGRESS,
  IMAP_IMAGE_UPLOAD_FAILED,
  IMAP_IMAGE_UPLOADED,
  IMAP_IMAGE_TO_UPLOAD,
  EDIT_BOOTH_DATA,
  ADD_BOOTH_DATA,
  INTERACTIVEMAPLOCATION_SESSION_LINK_DATA_WITH_EVENTID,
} from "IMapConstants";

import { fetchLocationMaps } from "LocationMapActions";
import axios from "axios";
import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  patchRequest,
} from "NetworkCall";
import { APP_API_KEY, BASE_IMAGES_URL, INSTANCE_URL } from "Constants";
import { getHeaders, getImageHeaders } from "CommonUtils";
import { UPLOAD_FILES_API_KEY } from "Constants";

export function fetchInteractiveMaps(session, callback) {
  //Fetch Speakers, Exhibitors and Sponsors
  //var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps?fields=*&related=*&filter=eventid%3D${session.eventid}&order=createdon%20DESC`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps?fields=*&related=interactivemap_locations_by_interactivemapid,interactivemap_locations_by_interactivemaplocation_exhibitor_link,exhibitors_by_interactivemaplocation_exhibitor_link,interactivemaplocation_exhibitor_link_by_interactivemapid,session_by_interactivemaplocation_session_link,interactivemaplocation_session_link_by_interactivemapid,speaker_by_interactivemaplocation_speaker_link,interactivemaplocation_speaker_link_by_interactivemapid,sponsor_by_interactivemaplocation_sponsor_link,interactivemaplocation_sponsor_link_by_interactivemapid&filter=eventid%3D${session.eventid}&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_INTERACTIVE_MAPS, payload: data });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
   
      }
    );
  };
}

export function fetchLinksResource(session) {
  //Fetch Speakers, Exhibitors and Sponsors
  //var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?fields=*&related=speaker_by_eventid%2Cexhibitors_by_eventid%2Csponsor_by_eventid&filter=eventid%3D${session.eventid}`;

  /* [ WILL UNCOMMENT ON NEXT BUILD ] */
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?fields=*&related=speaker_by_eventid%2Cexhibitors_by_eventid%2Csponsor_by_eventid%2Csession_by_eventid&filter=eventid%3D${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_LINK_RESOURCE, payload: data });
      },
      (error) => {

      }
    );
  };
}

export function imapImageToUpload(imagedata = {}) {
  return {
    type: IMAP_IMAGE_TO_UPLOAD,
    payload: imagedata,
  };
}

export function startFileUpload() {
  return {
    type: UPDATE_IMAP_UPLOAD_PROGRESS,
    payload: 0,
  };
}

export function updateUploadedImage(session, values) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps?fields=*`;
  var mapJson = { resource: { ...values } };
  var response = axios.patch(url, mapJson, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {


        //Reset upload failed to success
        dispatch({ type: IMAP_IMAGE_UPLOAD_FAILED, payload: false });

        //Reset the upload progress
        dispatch({ type: UPDATE_IMAP_UPLOAD_PROGRESS, payload: -1 });

        //Reset the data which contains the uploaded image data, we don't need it anymore
        dispatch({ type: IMAP_IMAGE_TO_UPLOAD, payload: {} });

        //Dispatch the response
        dispatch({ type: OPEN_IMAP, payload: data });

        dispatch(fetchInteractiveMaps(session, (callback) => {}));
      })
      .catch((error) => {

        //Reset the upload progress
        dispatch({ type: UPDATE_IMAP_UPLOAD_PROGRESS, payload: -1 });

        //Dispatch to tell there was an error
        dispatch({ type: IMAP_IMAGE_UPLOAD_FAILED, payload: true });
      });
  };
}

export function uploadNewiMapImage(imageData, session) {
  var imageBase64 = imageData.imagefile;
  var eventid = session.eventid;
  imageBase64 = imageBase64.replace(/^data:image\/[a-z]+;base64,/, "");
  var filename = `eventify/${eventid}/images/interactivemaps/${imageData.filename}.png`;
  var imageJson = {
    resource: [
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: imageBase64,
      },
    ],
  };

  return (dispatch) => {
    var config = {
      onUploadProgress: function (progressEvent) {
        var percentCompleted = progressEvent.loaded / progressEvent.total;
        dispatch({
          type: UPDATE_IMAP_UPLOAD_PROGRESS,
          payload: percentCompleted * 100,
        });
      },
      headers: {
        "X-DreamFactory-Api-Key": UPLOAD_FILES_API_KEY,
        "X-DreamFactory-Session-Token": session.sessionToken,
        contentType: "application/json; charset=utf-8",
      },
    };

    axios
      .post(`${BASE_IMAGES_URL}?check_exist=false`, imageJson, config)
      .then(function (res) {
        //debugger;
        var response = res.data.resource[0];
        var filePath = response.path;
        var thumbFilePath = response.path;
        /*var pathParts=_.split(filePath,'/');
          var thumbFilePath=`${pathParts[0]}/${pathParts[1]}/thumb_${pathParts[2]}`;*/
        dispatch(
          updateUploadedImage(session, {
            eventid: eventid,
            interactivemapid: imageData.interactivemapid,
            mapfilepath: filePath,
            thumbfilepath: thumbFilePath,
          })
        );
      })
      .catch(function (err) {
        //Reset the upload progress
        dispatch({ type: UPDATE_IMAP_UPLOAD_PROGRESS, payload: -1 });

        //Dispatch to tell there was an error
        dispatch({ type: IMAP_IMAGE_UPLOAD_FAILED, payload: true });
      });
  };
}

export function addBoothLink(
  session,
  values,
  type,
  successcallback,
  failurecallback
) {
  var interactivemapid = values.interactivemapid;

  return (dispatch) => {
    var table = "";
    switch (type) {
      case "exhibitor":
        table = "interactivemaplocation_exhibitor_link";
        break;
      case "sponsor":
        table = "interactivemaplocation_sponsor_link";
        break;
      case "speaker":
        table = "interactivemaplocation_speaker_link";
        break;
      case "session":
        table = "interactivemaplocation_session_link";
        break;
      default:
        table = "";
    }
    values = { resource: { ...values } };

    var url = `${INSTANCE_URL}/api/v2/eventify/_table/${table}?fields=*`;
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        if (response.resource.length > 0)
          dispatch(refreshSelectedMap(session, interactivemapid));
        successcallback(response.resource[0]);
      },
      (error) => {
        failurecallback();
      }
    );
  };
}

export function updateBoothColor(booth) {
  return {
    type: UPDATE_BOOTH_COLOR,
    payload: booth,
  };
}

export function openInteractiveMap(selectedMap = DEFAULT_IMAP_VALUE) {
  return {
    type: OPEN_IMAP,
    payload: selectedMap,
  };
}

export function refreshSelectedMap(session, interactivemapid) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps?fields=*&related=*&filter=interactivemapid%3D${interactivemapid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: OPEN_IMAP, payload: data.resource[0] });
        dispatch({ type: ADD_BOOTH_DATA, payload: {} });
        dispatch({ type: UPDATE_BOOTH_COLOR, payload: {} });
      },
      (error) => {

      }
    );
  };
}

export function deleteInteractiveMap(session, interactivemapid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps/${interactivemapid}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, data: data });
        dispatch(fetchInteractiveMaps(session, (callback) => {}));
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function saveBooth(
  session,
  values,
  interactivemapid,
  successcallback,
  failurecallback
) {
  return (dispatch) => {
    var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemap_locations?fields=*`;
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        dispatch(refreshSelectedMap(session, interactivemapid));
        dispatch(fetchInteractiveMaps(session, (callback) => {}));
        successcallback();
      },
      (error) => {
        failurecallback();
      }
    );
  };
}

export function updateBooth(
  session,
  values,
  interactivemapid,
  successcallback,
  failurecallback
) {
  var body = { ...values };
  return (dispatch) => {
    var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemap_locations?fields=*`;
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(refreshSelectedMap(session, interactivemapid));
        successcallback();
      },
      (error) => {
        failurecallback();
      }
    );
  };
}

export function addNewBooth(newbooth) {
  return (dispatch) => {
    dispatch({
      type: ADD_BOOTH,
      payload: { toEditBooth: false, toAddNewBooth: true },
    });
    dispatch({ type: ADD_BOOTH_DATA, payload: newbooth });
  };
}

export function showBoothEditor(show) {
  return {
    type: SHOW_BOOTH_EDITOR,
    payload: show,
  };
}

export function addInteractiveMapName(mapname) {
  return {
    type: ADD_IMAP_NAME,
    payload: mapname,
  };
}

export function editBooth(booth) {
  return (dispatch) => {
    dispatch({
      type: EDIT_BOOTH,
      payload: { toEditBooth: true, toAddNewBooth: false },
    });
    dispatch({ type: EDIT_BOOTH_DATA, payload: booth });
    dispatch({ type: SHOW_BOOTH_EDITOR, payload: true });
  };
}

export function addBoothData(booth) {
  return {
    type: ADD_BOOTH_DATA,
    payload: booth,
  };
}

export function editBoothData(booth) {
  return {
    type: EDIT_BOOTH_DATA,
    payload: booth,
  };
}

export function deleteBoothLinkOffline(values) {
  return (dispatch) => {
    dispatch({ type: DELETE_BOOTH_LINK, payload: values });
  };
}

export function deleteBoothLinkOnline(session, values, type, interactivemapid) {
  return (dispatch) => {
    var table = "";
    switch (type) {
      case "exhibitor":
        table = `interactivemaplocation_exhibitor_link/${values.linkid}`;
        break;
      case "sponsor":
        table = `interactivemaplocation_sponsor_link/${values.linkid}`;
        break;
      case "speaker":
        table = `interactivemaplocation_speaker_link/${values.linkid}`;
        break;
      case "session":
        table = `interactivemaplocation_session_link/${values.linkid}`;
        break;
      default:
        table = "";
    }

    var url = `${INSTANCE_URL}/api/v2/eventify/_table/${table}?fields=*`;

    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: DELETE_BOOTH_LINK, payload: values });
        dispatch(refreshSelectedMap(session, interactivemapid));
        dispatch(fetchInteractiveMaps(session, (callback) => {}));
      },
      (error) => {}
    );
  };
}

export function deleteBooth(session, booth, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemap_locations/${booth.locationid}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch(refreshSelectedMap(session, booth.interactivemapid));
        dispatch(fetchInteractiveMaps(session, (callback) => {}));
        callback({ error: 0, data: data });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

export function closeBooth(cancelledBooth = {}) {
  return (dispatch) => {
    dispatch({ type: CLOSE_BOOTH, payload: cancelledBooth });
    dispatch({ type: SHOW_BOOTH_EDITOR, payload: false });
    dispatch({ type: SHOW_ADD_BOOTH_INFO, payload: false });
  };
}

export function showAddBoothInfo(show) {
  return (dispatch) => {
    dispatch({ type: SHOW_ADD_BOOTH_INFO, payload: show });
  };
}

export function openiMapModal(open) {
  return (dispatch) => {
    dispatch({ type: OPEN_IMAP_MODAL, payload: open });
    if (!open) {
      dispatch({ type: SHOW_BOOTH_EDITOR, payload: false });
      dispatch({
        type: ADD_BOOTH,
        payload: { toEditBooth: false, toAddNewBooth: false },
      });
      dispatch({ type: UPDATE_BOOTH_COLOR, payload: {} });
      dispatch({ type: SHOW_ADD_BOOTH_INFO, payload: false });
      dispatch({ type: ADD_BOOTH_DATA, payload: {} });
    }
  };
}

export function changeMapImage(change = true) {
  return {
    type: CHANGE_MAP_IMAGE,
    payload: change,
  };
}

export function mapImageChanged(change = false) {
  return {
    type: MAP_IMAGE_CHANGED,
    payload: change,
  };
}

export function addMapWithName(values, session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps?fields=*`;

  var mapJson = {
    resource: {
      ...values,
      eventid: session.eventid,
      thumbfilepath: "",
      mapfilepath: "",
    },
  };
  var response = axios.post(url, mapJson, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch({ type: ADD_IMAP_NAME, payload: values.mapname });
        dispatch({ type: OPEN_IMAP, payload: data });
        dispatch(fetchInteractiveMaps(session, (callback) => {}));
      })
      .catch((error) => {});
  };
}

export function updateMapWithName(values, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps?fields=*`;
  var mapJson = { resource: { ...values } };
  var response = axios.patch(url, mapJson, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch({ type: ADD_IMAP_NAME, payload: values.mapname });
        dispatch({ type: OPEN_IMAP, payload: data });
        var returnData = { error: 0, data: data };
        callback(returnData);
        dispatch(fetchInteractiveMaps(session, (callback) => {}));
      })
      .catch((error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      });
  };
}

export function updateInteractiveMap(values, session, callfor, callback) {
  var url = "";
  if (callfor) {
    //url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps?fields=*`;
    url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaps?fields=displayorder,eventid,interactivemapid`;
  } else {
    //url = `${INSTANCE_URL}/api/v2/eventify/_table/locationmaps?fields=*`;
    url = `${INSTANCE_URL}/api/v2/eventify/_table/locationmaps?fields=*`;
  }

  let newValues = _.map(values, function (value) {
    if (value.exhibitors_by_interactivemaplocation_exhibitor_link) {
      let filterObject = _.omit(value, [
        "exhibitors_by_interactivemaplocation_exhibitor_link",
        "interactivemap_locations_by_interactivemapid",
        "interactivemap_locations_by_interactivemaplocation_exhibitor_link",
        "interactivemaplocation_exhibitor_link_by_interactivemapid",
        "interactivemaplocation_session_link_by_interactivemapid",
        "interactivemaplocation_speaker_link_by_interactivemapid",
        "interactivemaplocation_sponsor_link_by_interactivemapid",
        "session_by_interactivemaplocation_session_link",
        "speaker_by_interactivemaplocation_speaker_link",
        "sponsor_by_interactivemaplocation_sponsor_link",
        "thumbfilepath",
        "mapname",
        "mapfilepath",
      ]);

      return filterObject;
    } else {
      return value;
    }
  });

  var mapJson = { resource: { ...newValues } };
  var response = axios.patch(url, mapJson, getHeaders(session));

  return (dispatch) => {
    response
      .then(({ data }) => {
        // var returnData = {error:0,data:data};

        if (callfor) {
          dispatch(fetchInteractiveMaps(session, (callback) => {}));
        } else {
          dispatch(fetchLocationMaps(session, (callback) => {}));
        }

        callback({ success: 1 });
      })
      .catch((error) => {
        var returnData = { error: 1, data: error };
        callback(returnData);
      });
  };
}

/* Will use this to fetch data from "interactivemaplocation_session_link" 
    and remove this datas from "Search & Link with Booth" for session only
    */
export function fetchInteractiveMapLocationSessionLinkWithEvventID(
  session,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interactivemaplocation_session_link?fields=*&filter=eventid%3D${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: INTERACTIVEMAPLOCATION_SESSION_LINK_DATA_WITH_EVENTID,
          payload: data.resource,
        });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
  
      }
    );
  };
}
